import React from "react";

const SIZE_CLASS_MAP = {
  sm: "icon-sm",
  md: "icon-md",
  lg: "icon-lg",
};

export const Icon = ({ name, size = "md", className = "", ...rest }) => {
  const sizeClass = SIZE_CLASS_MAP[size] || SIZE_CLASS_MAP.md;
  const classes = ["fa", `fa-${name}`, sizeClass, className]
    .filter(Boolean)
    .join(" ");

  return <i className={classes} aria-hidden="true" {...rest} />;
};

export default Icon;

